import { directus, nodeAPI } from "../Config/ApiUrls";
import { Api } from "../Config/Requests";
import { storage } from "../Config/Storage";

export const requestlogin = async (data) => {
    return Api.PostRequest(nodeAPI + `sendotp`, data);
};
export const requestverify = async (data) => {
   return Api.PostRequest(nodeAPI + `verifyotp`, data)
};

export const requestroles = async () => {
    return Api.GetRequest(directus +'roles')
}

export const requestchoosetype = async (data) => {
    const phone = storage.fetch.phone()
    let token = await Api.GetRequest(directus +`utils/random/string`)
    let update = await Api.PatchRequest(directus + `users/${phone}`, { token: token?.data?.data, userrole: data.role  })
    if (update) {
        return { status: true, token: token?.data?.data, data: update?.data?.data }
    } else {
        return { status: false }
    }
};


// Define All User APIs
const LoginApiRequests = {
    requestlogin,
    requestverify,
    requestroles,
    requestchoosetype
};
export default LoginApiRequests;